import React from 'react'

import './header-market.scss'

const HeaderMarket = ({title}) => {
    return (
        <>
            <div className="f-header-games">
                <div className="f-title-site-container">
                    <h1 className="f-title-site">{title}</h1>
                </div>
                <span className="f-lateral-img-purple" />
            </div>
            <span className="f-lateral-img-blue" />
        </>
    )
}

export default HeaderMarket
